var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g2, _path44, _path45, _path46, _g3, _path47, _path48, _path49, _path50, _path51, _g4, _path52, _path53, _path54, _path55, _path56, _path57, _g5, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g6, _path67, _path68, _path69, _path70, _g7, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _g8, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _g9, _path107, _path108, _path109, _path110, _path111, _path112, _path113;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessdealBro1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    viewBox: "0 0 232 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.719 51.55H124.208L124.547 46.6641H158.057L157.719 51.55Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.719 58.3937H124.208L124.547 53.5078H158.057L157.719 58.3937Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.719 65.2421H124.208L124.547 60.3516H158.057L157.719 65.2421Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.719 72.0859H124.208L124.547 67.1953H158.057L157.719 72.0859Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.719 78.9296H124.208L124.547 74.0391H158.057L157.719 78.9296Z",
    fill: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.719 85.7765H124.208L124.547 80.8906H158.057L157.719 85.7765Z",
    fill: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.719 92.6203H124.208L124.547 87.7344H158.057L157.719 92.6203Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.719 99.4687H124.208L124.547 94.5781H158.057L157.719 99.4687Z",
    fill: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.719 106.312H124.208L124.547 101.422H158.057L157.719 106.312Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M157.719 113.156H124.208L124.547 108.266H158.057L157.719 113.156Z",
    fill: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M157.719 120H124.208L124.547 115.109H158.057L157.719 120Z",
    fill: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M193.154 51.55H159.64L159.978 46.6641H193.493L193.154 51.55Z",
    fill: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M193.154 58.3937H159.64L159.978 53.5078H193.493L193.154 58.3937Z",
    fill: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M193.154 65.2421H159.64L159.978 60.3516H193.493L193.154 65.2421Z",
    fill: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M193.154 72.0859H159.64L159.978 67.1953H193.493L193.154 72.0859Z",
    fill: "#CCCCCC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M193.154 78.9296H159.64L159.978 74.0391H193.493L193.154 78.9296Z",
    fill: "#CCCCCC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M193.154 85.7765H159.64L159.978 80.8906H193.493L193.154 85.7765Z",
    fill: "#CCCCCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M193.154 92.6203H159.64L159.978 87.7344H193.493L193.154 92.6203Z",
    fill: "#CCCCCC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M193.154 99.4687H159.64L159.978 94.5781H193.493L193.154 99.4687Z",
    fill: "#CCCCCC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M193.154 106.312H159.64L159.978 101.422H193.493L193.154 106.312Z",
    fill: "#CCCCCC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M193.154 113.156H159.64L159.978 108.266H193.493L193.154 113.156Z",
    fill: "#CCCCCC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M193.154 120H159.64L159.978 115.109H193.493L193.154 120Z",
    fill: "#CCCCCC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M119.508 46.4062H50.27V105.808H119.508V46.4062Z",
    fill: "#548AFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M116.042 49.375H53.7314V102.837H116.042V49.375Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4014_25745",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 49,
    width: 64,
    height: 54
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M116.042 49.375H53.7319V102.837H116.042V49.375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4014_25745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.042 65.5859C104.837 73.5575 88.7871 78.8471 70.1668 87.1573C64.2995 89.7337 58.7782 93.0353 53.7319 96.9848V102.845H116.042V65.5859Z",
    fill: "#548AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.042 49.375H91.0374C88.2534 51.7553 84.9637 54.414 81.0754 57.263C66.8445 67.6984 73.011 78.143 90.0909 70.5427C98.8558 66.6497 108.614 57.6342 116.042 49.7787V49.375Z",
    fill: "#548AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.497 55.3749C64.497 51.018 59.0728 54.4469 53.7554 58.8271V69.8285C58.929 64.7524 64.497 59.2725 64.497 55.3749Z",
    fill: "#548AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6938 72.6865C69.6938 73.6721 69.4015 74.6356 68.8539 75.4551C68.3063 76.2746 67.5281 76.9133 66.6175 77.2905C65.7069 77.6677 64.7049 77.7664 63.7382 77.5741C62.7715 77.3818 61.8836 76.9072 61.1866 76.2103C60.4897 75.5133 60.0151 74.6254 59.8228 73.6587C59.6305 72.692 59.7292 71.69 60.1064 70.7794C60.4836 69.8688 61.1223 69.0906 61.9418 68.543C62.7613 67.9954 63.7248 67.7031 64.7104 67.7031C66.0321 67.7031 67.2996 68.2282 68.2342 69.1627C69.1687 70.0973 69.6938 71.3648 69.6938 72.6865Z",
    fill: "#548AFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M116.042 65.5859C104.837 73.5575 88.7871 78.8471 70.1668 87.1573C64.2995 89.7337 58.7782 93.0353 53.7319 96.9848V102.845H116.042V65.5859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M116.042 49.375H91.0374C88.2534 51.7553 84.9637 54.414 81.0754 57.263C66.8445 67.6984 73.011 78.143 90.0909 70.5427C98.8558 66.6497 108.614 57.6342 116.042 49.7787V49.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.4965 55.3749C64.4965 51.018 59.0723 54.4469 53.7549 58.8271V69.8285C58.9285 64.7524 64.4965 59.2725 64.4965 55.3749Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M69.6938 72.6865C69.6938 73.6721 69.4015 74.6356 68.8539 75.4551C68.3063 76.2746 67.5281 76.9133 66.6175 77.2905C65.7069 77.6677 64.7049 77.7664 63.7382 77.5741C62.7715 77.3818 61.8836 76.9072 61.1866 76.2103C60.4897 75.5133 60.0151 74.6254 59.8228 73.6587C59.6305 72.692 59.7292 71.69 60.1064 70.7794C60.4836 69.8688 61.1223 69.0906 61.9418 68.543C62.7613 67.9954 63.7248 67.7031 64.7104 67.7031C66.0321 67.7031 67.2996 68.2282 68.2342 69.1627C69.1687 70.0973 69.6938 71.3648 69.6938 72.6865Z",
    fill: "white"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M105.272 88.5742C105.272 89.8885 104.883 91.1733 104.152 92.2661C103.422 93.3589 102.384 94.2105 101.17 94.7133C99.9552 95.2161 98.6189 95.3474 97.3299 95.0906C96.0409 94.8339 94.8569 94.2006 93.9279 93.2709C92.9988 92.3412 92.3664 91.1568 92.1105 89.8676C91.8547 88.5784 91.9869 87.2423 92.4905 86.0282C92.9941 84.8142 93.8465 83.7768 94.9398 83.0472C96.0331 82.3177 97.3182 81.9288 98.6325 81.9297C99.5049 81.9297 100.369 82.1016 101.175 82.4356C101.98 82.7695 102.713 83.259 103.329 83.8761C103.946 84.4931 104.435 85.2257 104.768 86.0318C105.102 86.8379 105.273 87.7018 105.272 88.5742Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M198.936 168.844C197.731 170.241 196.918 171.931 196.579 173.744L191.85 176.394V163.866L191.943 163.991L199.474 158.479C200.425 158.627 204.081 159.045 207.413 157.249C211.283 155.166 214.109 148.029 214.109 148.029C214.109 148.029 204.884 146.985 201.761 150.855C199.228 153.992 199.14 157.031 199.2 158.066L191.85 163.443V154.187C193.227 153.546 194.444 152.606 195.412 151.437C196.381 150.268 197.077 148.898 197.451 147.426C198.787 142.22 191.651 131.961 191.651 131.961C191.651 131.961 184.227 142.522 185.698 147.876C186.96 152.409 190.338 153.848 191.354 154.182V174.25L186.064 169.828C186.185 168.77 186.282 165.462 183.336 162.149C179.763 158.131 170.247 158.437 170.247 158.437C170.247 158.437 174.26 166.469 177.671 169.146C180.659 171.466 184.784 170.538 185.777 170.255L191.345 174.895V180.996H183.062L186.445 202.136H196.593L199.984 181.001H191.85V176.964L197.047 174.05C198.309 174.403 201.84 175.127 205.181 173.456C209.357 171.373 212.768 166.909 212.768 166.909C212.768 166.909 202.805 164.381 198.936 168.844Z",
    fill: "#548AFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M198.936 168.844C197.731 170.241 196.918 171.931 196.579 173.744L191.85 176.394V163.866L191.943 163.991L199.474 158.479C200.425 158.627 204.081 159.045 207.413 157.249C211.283 155.166 214.109 148.029 214.109 148.029C214.109 148.029 204.884 146.985 201.761 150.855C199.228 153.992 199.14 157.031 199.2 158.066L191.85 163.443V154.187C193.227 153.546 194.444 152.606 195.412 151.437C196.381 150.268 197.077 148.898 197.451 147.426C198.787 142.22 191.651 131.961 191.651 131.961C191.651 131.961 184.227 142.522 185.698 147.876C186.96 152.409 190.338 153.848 191.354 154.182V174.25L186.064 169.828C186.185 168.77 186.282 165.462 183.336 162.149C179.763 158.131 170.247 158.437 170.247 158.437C170.247 158.437 174.26 166.469 177.671 169.146C180.659 171.466 184.784 170.538 185.777 170.255L191.345 174.895V180.996H183.062L186.445 202.136H196.593L199.984 181.001H191.85V176.964L197.047 174.05C198.309 174.403 201.84 175.127 205.181 173.456C209.357 171.373 212.768 166.909 212.768 166.909C212.768 166.909 202.805 164.381 198.936 168.844Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M189.558 104.964L175.903 105.08C175.903 105.08 174.975 104.964 174.775 105.642C174.775 105.642 172.404 111.627 172.293 113.771C172.181 115.915 172.757 115.576 171.829 118.411C170.901 121.246 168.33 127.89 166.864 133.31C164.892 140.59 164.377 148.32 164.252 155.837C164.252 157.043 163.509 167.437 165.388 167.437C166.947 167.437 181.317 169.344 181.489 166.574C182.181 155.531 180.185 144.743 184.018 134.006C185.507 129.83 187.215 125.431 188.482 121.07C189.748 116.708 189.966 112.17 190.802 107.706C191.363 104.625 189.558 104.964 189.558 104.964Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M190.899 106.319C190.764 104.741 189.558 104.964 189.558 104.964L175.903 105.08C175.903 105.08 174.975 104.964 174.775 105.641C174.775 105.641 172.404 111.627 172.293 113.771C172.259 114.337 172.275 114.905 172.339 115.469L172.627 115.933C172.627 115.933 173.091 119.882 178.496 120.109C183.902 120.336 186.964 117.849 188.092 115.469C189.219 113.089 189.674 109.261 190.574 107.001C190.671 106.768 190.779 106.541 190.899 106.319Z",
    fill: "#548AFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M187.73 110.729C186.802 114.028 187.363 114.942 186.449 120.622C185.535 126.301 182.236 132.686 180.951 138.574C179.665 144.462 180.222 165.133 180.403 166.052C180.475 166.539 180.501 167.031 180.482 167.523C181.099 167.291 181.47 166.975 181.498 166.544C182.189 155.501 180.194 144.713 184.027 133.976C185.516 129.8 187.224 125.401 188.491 121.039C189.757 116.678 189.975 112.14 190.811 107.676C191.159 105.82 190.611 105.212 190.133 105.031C189.095 106.822 188.288 108.736 187.73 110.729Z",
    fill: "#548AFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M161.351 194.08L161.259 194.006V181.255H163.091V173.195H156.317V181.255H158.145V194.224L141.933 199.393V200.673C141.933 201.062 142.088 201.435 142.363 201.71C142.638 201.985 143.01 202.14 143.399 202.14C143.788 202.14 144.161 201.985 144.436 201.71C144.711 201.435 144.866 201.062 144.866 200.673V200.492L158.424 198.915V200.859C158.424 201.199 158.559 201.524 158.799 201.765C159.039 202.005 159.365 202.14 159.704 202.14C160.044 202.14 160.37 202.005 160.61 201.765C160.85 201.524 160.985 201.199 160.985 200.859V198.85L175.091 200.492V200.673C175.091 201.062 175.245 201.435 175.52 201.71C175.795 201.985 176.168 202.14 176.557 202.14C176.946 202.14 177.319 201.985 177.594 201.71C177.869 201.435 178.023 201.062 178.023 200.673V199.393L161.351 194.08Z",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M180.682 165.328H140.42C139.395 165.328 138.564 166.159 138.564 167.184V172.822C138.564 173.847 139.395 174.678 140.42 174.678H180.682C181.707 174.678 182.538 173.847 182.538 172.822V167.184C182.538 166.159 181.707 165.328 180.682 165.328Z",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1981 104.964L35.8537 105.08C35.8537 105.08 36.7817 104.964 36.9858 105.642C36.9858 105.642 39.3569 111.627 39.4682 113.771C39.5796 115.915 39.0042 115.576 39.9322 118.411C40.8602 121.246 43.4308 127.89 44.897 133.31C46.8737 140.59 47.3841 148.32 47.5093 155.837C47.5093 157.043 48.2517 167.437 46.3725 167.437C44.8181 167.437 30.4481 169.344 30.2717 166.574C29.585 155.531 31.5756 144.743 27.7429 134.006C26.2535 129.83 24.546 125.431 23.2839 121.07C22.0218 116.708 21.7991 112.17 20.9639 107.706C20.4164 104.625 22.1981 104.964 22.1981 104.964Z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8794 106.319C21.014 104.741 22.2157 104.964 22.2157 104.964L35.8712 105.08C35.8712 105.08 36.7992 104.964 37.0034 105.641C37.0034 105.641 39.3744 111.627 39.4858 113.771C39.516 114.337 39.4989 114.905 39.4348 115.469L39.1471 115.933C39.1471 115.933 38.6831 119.882 33.2775 120.109C27.8719 120.336 24.7956 117.849 23.6634 115.464C22.5312 113.079 22.0858 109.256 21.181 106.996C21.0937 106.765 20.993 106.539 20.8794 106.319Z",
    fill: "#548AFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0261 110.729C24.9541 114.028 24.3927 114.942 25.3068 120.622C26.2209 126.301 29.5245 132.686 30.8052 138.574C32.0858 144.462 31.5522 165.133 31.3527 166.052C31.2831 166.539 31.2568 167.031 31.2738 167.523C30.6613 167.291 30.2855 166.975 30.2577 166.544C29.5709 155.501 31.5615 144.713 27.7289 133.976C26.2394 129.8 24.5319 125.401 23.2698 121.039C22.0077 116.678 21.785 112.14 20.9498 107.676C20.6065 105.82 21.154 105.212 21.6273 105.031C22.6656 106.821 23.4718 108.736 24.0261 110.729Z",
    fill: "#548AFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4046 194.08L50.4974 194.006V181.255H48.6414V173.195H55.4204V181.255H53.5876V194.224L69.7997 199.393V200.673C69.7997 201.062 69.6453 201.435 69.3703 201.71C69.0953 201.985 68.7224 202.14 68.3335 202.14C67.9446 202.14 67.5717 201.985 67.2967 201.71C67.0217 201.435 66.8673 201.062 66.8673 200.673V200.492L53.3602 198.915V200.859C53.3406 201.186 53.1968 201.493 52.9584 201.718C52.7199 201.942 52.4048 202.067 52.0773 202.067C51.7498 202.067 51.4346 201.942 51.1962 201.718C50.9577 201.493 50.814 201.186 50.7943 200.859V198.85L36.6562 200.492V200.673C36.6675 200.873 36.6379 201.072 36.5694 201.259C36.5009 201.447 36.3949 201.618 36.2579 201.763C36.1208 201.908 35.9556 202.024 35.7724 202.102C35.5892 202.181 35.3918 202.222 35.1923 202.222C34.9928 202.222 34.7954 202.181 34.6122 202.102C34.429 202.024 34.2638 201.908 34.1268 201.763C33.9897 201.618 33.8837 201.447 33.8152 201.259C33.7467 201.072 33.7172 200.873 33.7284 200.673V199.393L50.4046 194.08Z",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0741 174.68H71.3354C72.3604 174.68 73.1914 173.849 73.1914 172.824V167.186C73.1914 166.161 72.3604 165.33 71.3354 165.33H31.0741C30.0491 165.33 29.2181 166.161 29.2181 167.186V172.824C29.2181 173.849 30.0491 174.68 31.0741 174.68Z",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M172.608 139.07H62.3618V202.434H172.608V139.07Z",
    fill: "#CCCCCC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M172.525 140.594H62.4175V142.348H172.525V140.594Z",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M173.425 138.031H59.9072V140.801H173.425V138.031Z",
    fill: "#CCCCCC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7141 132.531C91.7141 132.531 93.0133 138.336 92.939 139.955C92.8648 141.575 89.807 145.913 89.7281 144.92C89.7541 144.079 89.9366 143.249 90.2664 142.475C90.2664 142.475 89.1945 143.927 88.8141 143.867C88.4336 143.806 89.1203 141.802 89.1203 141.802C89.1203 141.802 87.9742 142.948 87.5891 142.73C87.204 142.512 88.4289 140.818 88.4289 140.818C88.4289 140.818 87.0369 142.271 86.9813 141.811C86.9256 141.352 88.2016 139.445 88.2016 139.445C88.2016 139.445 86.9024 136.693 86.8096 135.547C86.8179 134.747 87.0848 133.97 87.5705 133.334L91.7141 132.531Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4014_25745",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 132,
    width: 7,
    height: 14
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7145 132.539C91.7145 132.539 93.0137 138.344 92.9395 139.963C92.8653 141.582 89.8075 145.921 89.7286 144.928C89.7545 144.086 89.9371 143.257 90.2669 142.483C90.2669 142.483 89.195 143.935 88.8145 143.875C88.4341 143.814 89.1208 141.81 89.1208 141.81C89.1208 141.81 87.9747 142.956 87.5896 142.738C87.2045 142.52 88.4294 140.826 88.4294 140.826C88.4294 140.826 87.0374 142.278 86.9817 141.819C86.9261 141.36 88.2021 139.453 88.2021 139.453C88.2021 139.453 86.9029 136.701 86.8101 135.555C86.8184 134.755 87.0853 133.978 87.571 133.342L91.7145 132.539Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4014_25745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.7145 132.539C91.7145 132.539 93.0137 138.344 92.9395 139.963C92.8653 141.582 89.8075 145.921 89.7286 144.928C89.7545 144.086 89.9371 143.257 90.2669 142.483C90.2669 142.483 89.195 143.935 88.8145 143.875C88.4341 143.814 89.1208 141.81 89.1208 141.81C89.1208 141.81 87.9747 142.956 87.5896 142.738C87.2045 142.52 88.4294 140.826 88.4294 140.826C88.4294 140.826 87.0374 142.278 86.9817 141.819C86.9261 141.36 88.2021 139.453 88.2021 139.453C88.2021 139.453 86.9029 136.701 86.8101 135.555C86.8184 134.755 87.0853 133.978 87.571 133.342L91.7145 132.539Z",
    fill: "#D9D9D9"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7141 132.531C91.7141 132.531 93.0133 138.336 92.939 139.955C92.8648 141.575 89.807 145.913 89.7281 144.92C89.7541 144.079 89.9366 143.249 90.2664 142.475C90.2664 142.475 89.1945 143.927 88.8141 143.867C88.4336 143.806 89.1203 141.802 89.1203 141.802C89.1203 141.802 87.9742 142.948 87.5891 142.73C87.204 142.512 88.4289 140.818 88.4289 140.818C88.4289 140.818 87.0369 142.271 86.9813 141.811C86.9256 141.352 88.2016 139.445 88.2016 139.445C88.2016 139.445 86.9024 136.693 86.8096 135.547C86.8179 134.747 87.0848 133.97 87.5705 133.334L91.7141 132.531Z",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4083 132.531C91.4083 132.531 92.3363 136.582 92.2528 137.728C92.1693 138.874 91.0278 142.233 90.188 141.621C89.3481 141.009 90.7216 138.721 90.7216 138.721C90.7216 138.721 88.3645 137.065 87.8216 135.51C87.2787 133.956 87.5896 133.297 87.5896 133.297L91.4083 132.531Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4014_25745",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 132,
    width: 6,
    height: 10
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4073 132.539C91.4073 132.539 92.3353 136.59 92.2518 137.736C92.1683 138.882 91.0268 142.241 90.187 141.629C89.3472 141.016 90.7206 138.729 90.7206 138.729C90.7206 138.729 88.3635 137.072 87.8206 135.518C87.2777 133.964 87.5886 133.305 87.5886 133.305L91.4073 132.539Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4014_25745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.4073 132.539C91.4073 132.539 92.3353 136.59 92.2518 137.736C92.1683 138.882 91.0268 142.241 90.187 141.629C89.3472 141.016 90.7206 138.729 90.7206 138.729C90.7206 138.729 88.3635 137.072 87.8206 135.518C87.2777 133.964 87.5886 133.305 87.5886 133.305L91.4073 132.539Z",
    fill: "#D9D9D9"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4083 132.531C91.4083 132.531 92.3363 136.582 92.2528 137.728C92.1693 138.874 91.0278 142.233 90.188 141.621C89.3481 141.009 90.7216 138.721 90.7216 138.721C90.7216 138.721 88.3645 137.065 87.8216 135.51C87.2787 133.956 87.5896 133.297 87.5896 133.297L91.4083 132.531Z",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6103 113.547L91.863 132.919L87.2787 133.954L82.6943 119.017L88.6103 113.547Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2785 123.019C87.2785 123.019 87.5754 146.09 88.0162 152.303C88.457 158.515 86.833 166.798 85.3575 169.164C83.882 171.531 77.3674 186.332 77.6644 187.209C77.9614 188.086 79.293 190.759 79.293 191.497V194.601C79.293 194.601 86.6846 199.482 87.2785 199.482C87.8724 199.482 88.6102 200.665 87.13 201.556C85.6498 202.447 69.085 202.442 68.3473 201.848C67.8606 201.412 67.5028 200.85 67.3126 200.224C67.3126 200.224 64.9462 201.111 65.0946 198.893C65.2431 196.675 67.9018 187.209 67.9018 187.209C67.9018 187.209 66.2778 176.853 66.8671 170.199C67.4564 163.545 69.5305 155.555 69.5305 153.931C69.5305 152.307 67.461 141.505 67.1641 139.733C66.8671 137.96 62.5798 132.926 64.5007 128.935C66.4217 124.945 67.9018 118.579 68.4958 118.138C69.0897 117.697 77.0751 117.396 80.3278 118.138C83.5804 118.881 87.13 118.876 87.2785 123.019Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6159 76.5161C72.6159 76.5161 70.0871 78.7804 69.651 79.5646C69.2148 80.3487 63.9066 87.9166 63.8185 93.3268C63.7303 98.737 67.7439 115.098 67.7439 115.098L61.7119 130.442L63.4566 131.138L65.1966 129.222V132.099C65.1966 132.099 67.201 133.927 72.4257 135.667C77.6503 137.407 84.3598 135.407 84.3598 135.407L86.3596 122.675V135.235L88.7121 133.667L88.9023 112.75C88.9023 112.75 90.8186 101.516 90.8186 98.3658C90.8186 95.2153 85.5058 85.3738 83.1534 82.5156C80.8009 79.6574 76.8801 77.291 75.7294 76.4186C74.5786 75.5463 72.6159 76.5161 72.6159 76.5161Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4014_25745",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 76,
    width: 30,
    height: 61
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6159 76.5083C72.6159 76.5083 70.0871 78.7726 69.651 79.5567C69.2148 80.3409 63.9066 87.9087 63.8185 93.319C63.7303 98.7292 67.7439 115.09 67.7439 115.09L61.7119 130.434L63.4566 131.13L65.1966 129.214V132.091C65.1966 132.091 67.201 133.919 72.4257 135.659C77.6503 137.399 84.3598 135.399 84.3598 135.399L86.3596 122.667V135.227L88.7121 133.659L88.9023 112.742C88.9023 112.742 90.8186 101.509 90.8186 98.358C90.8186 95.2075 85.5058 85.366 83.1534 82.5078C80.8009 79.6495 76.8801 77.2831 75.7294 76.4108C74.5786 75.5385 72.6159 76.5083 72.6159 76.5083Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4014_25745)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M72.6159 76.5083C72.6159 76.5083 70.0871 78.7726 69.651 79.5567C69.2148 80.3409 63.9066 87.9087 63.8185 93.319C63.7303 98.7292 67.7439 115.09 67.7439 115.09L61.7119 130.434L63.4566 131.13L65.1966 129.214V132.091C65.1966 132.091 67.201 133.919 72.4257 135.659C77.6503 137.399 84.3598 135.399 84.3598 135.399L86.3596 122.667V135.227L88.7121 133.659L88.9023 112.742C88.9023 112.742 90.8186 101.509 90.8186 98.358C90.8186 95.2075 85.5058 85.366 83.1534 82.5078C80.8009 79.6495 76.8801 77.2831 75.7294 76.4108C74.5786 75.5385 72.6159 76.5083 72.6159 76.5083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1733 95.0547C65.1733 95.0547 68.3378 97.2958 70.4444 98.0846",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0967 97.4297C66.0967 97.4297 69.6556 98.3577 71.4976 98.3577",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2378 118.508L81.2509 119.696L80.592 121.802L71.3677 120.749",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6159 76.5161C72.6159 76.5161 70.0871 78.7804 69.651 79.5646C69.2148 80.3487 63.9066 87.9166 63.8185 93.3268C63.7303 98.737 67.7439 115.098 67.7439 115.098L61.7119 130.442L63.4566 131.138L65.1966 129.222V132.099C65.1966 132.099 67.201 133.927 72.4257 135.667C77.6503 137.407 84.3598 135.407 84.3598 135.407L86.3596 122.675V135.235L88.7121 133.667L88.9023 112.75C88.9023 112.75 90.8186 101.516 90.8186 98.3658C90.8186 95.2153 85.5058 85.3738 83.1534 82.5156C80.8009 79.6574 76.8801 77.291 75.7294 76.4186C74.5786 75.5463 72.6159 76.5161 72.6159 76.5161Z",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0918 77.0234L81.7616 87.4774L87.4224 98.2793C87.4224 98.2793 86.202 90.266 85.158 88.0713C84.114 85.8766 79.4091 80.4385 78.8801 79.2182C78.3512 77.9978 72.0918 77.0234 72.0918 77.0234Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7452 93.174L87.4225 98.278C87.4225 98.278 86.5919 92.8167 85.7103 89.6847L85.1581 88.0839C84.4169 86.7835 83.5761 85.5425 82.6433 84.3719L81.126 84.0703L81.7617 87.4854L83.7197 89.0862L84.7452 93.174Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1648 80.9531L82.666 81.5331L84.2389 83.3891L85.1669 88.1034L81.1348 84.0805C81.1348 84.0805 81.6637 81.6538 82.1648 80.9531Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7259 61.526C86.7259 61.526 88.8417 63.15 89.1062 64.7183C89.3707 66.2866 88.5819 68.0313 88.67 68.6391C88.7582 69.247 90.3219 70.6436 90.2384 71.3396C90.1548 72.0356 88.8464 72.2954 88.8464 72.2954C88.8464 72.2954 87.4265 77.4644 87.0785 78.3274C86.7305 79.1905 84.9859 78.9353 83.682 78.7636L81.3296 85.7236L73.5715 76.5967L74.7918 72.9358C74.7918 72.9358 71.4835 68.9314 71.219 64.6626C70.9545 60.3938 74.3556 57.4335 79.2323 56.8257C84.1089 56.2178 88.206 58.5657 88.7257 59.5262C89.2454 60.4866 86.7259 61.526 86.7259 61.526Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4014_25745",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 56,
    width: 20,
    height: 30
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7259 61.526C86.7259 61.526 88.8417 63.15 89.1062 64.7183C89.3707 66.2866 88.5819 68.0313 88.67 68.6391C88.7582 69.247 90.3219 70.6436 90.2384 71.3396C90.1548 72.0356 88.8464 72.2954 88.8464 72.2954C88.8464 72.2954 87.4265 77.4644 87.0785 78.3274C86.7305 79.1905 84.9859 78.9353 83.682 78.7636L81.3296 85.7236L73.5715 76.5967L74.7918 72.9358C74.7918 72.9358 71.4835 68.9314 71.219 64.6626C70.9545 60.3938 74.3556 57.4335 79.2323 56.8257C84.1089 56.2178 88.206 58.5657 88.7257 59.5262C89.2454 60.4866 86.7259 61.526 86.7259 61.526Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4014_25745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.7264 61.526C86.7264 61.526 88.8422 63.15 89.1067 64.7183C89.3712 66.2866 88.5824 68.0313 88.6705 68.6391C88.7587 69.247 90.3224 70.6436 90.2388 71.3396C90.1553 72.0356 88.8468 72.2954 88.8468 72.2954C88.8468 72.2954 87.427 77.4644 87.079 78.3274C86.731 79.1905 84.9864 78.9353 83.6825 78.7636L81.3301 85.7236L73.572 76.5967L74.7923 72.9358C74.7923 72.9358 71.484 68.9314 71.2195 64.6626C70.955 60.3938 74.3561 57.4335 79.2328 56.8257C84.1094 56.2178 88.2065 58.5657 88.7262 59.5262C89.2459 60.4866 86.7264 61.526 86.7264 61.526Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6876 81.4512C78.9961 81.1867 81.1908 80.732 83.1674 80.2865L83.6778 78.7739C84.7636 78.9177 86.1556 79.1219 86.7866 78.6811C85.3018 78.0686 81.6269 76.9968 80.8753 75.6187C79.9473 73.9065 83.1953 68.9232 83.1953 66.4315C83.1953 63.9398 80.0818 61.1373 80.0818 61.1373C78.5831 59.7128 75.8501 59.2812 73.4234 59.2812C72.6595 59.9483 72.0614 60.784 71.6765 61.7223C71.2915 62.6605 71.1303 63.6755 71.2055 64.6868C71.47 68.9556 74.7783 72.96 74.7783 72.96L73.558 76.6209L77.6876 81.4512Z",
    fill: "#B8B8B8"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7259 61.526C86.7259 61.526 88.8417 63.15 89.1062 64.7183C89.3707 66.2866 88.5819 68.0313 88.67 68.6391C88.7582 69.247 90.3219 70.6436 90.2384 71.3396C90.1548 72.0356 88.8464 72.2954 88.8464 72.2954C88.8464 72.2954 87.4265 77.4644 87.0785 78.3274C86.7305 79.1905 84.9859 78.9353 83.682 78.7636L81.3296 85.7236L73.5715 76.5967L74.7918 72.9358C74.7918 72.9358 71.4835 68.9314 71.219 64.6626C70.9545 60.3938 74.3556 57.4335 79.2323 56.8257C84.1089 56.2178 88.206 58.5657 88.7257 59.5262C89.2454 60.4866 86.7259 61.526 86.7259 61.526Z",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7259 61.5271C86.7259 61.5271 89.2501 60.4831 88.7257 59.5272C88.2014 58.5714 84.1089 56.2143 79.2323 56.8267C74.3557 57.4392 70.9592 60.3949 71.219 64.6637C71.4789 68.9325 74.7918 72.9368 74.7918 72.9368L74.6062 73.4936C76.4112 74.3752 78.2765 72.9368 78.2765 72.9368C77.9359 73.1086 77.5495 73.1674 77.1733 73.1049C76.797 73.0423 76.4505 72.8616 76.1838 72.5888C75.1398 71.633 75.0517 68.5845 76.3601 68.32C77.6686 68.0555 78.5363 68.5845 78.5363 69.5403C78.5363 70.4962 78.7961 69.8883 79.4968 69.8002C80.1974 69.712 79.5803 67.624 80.0165 67.276C80.7215 66.8397 81.3411 66.2783 81.8446 65.6195C82.6288 64.5755 80.3645 63.7079 80.1046 62.7474C79.8448 61.7869 86.7259 61.5271 86.7259 61.5271Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3476 68.3359L85.7329 68.8742H87.1945",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9653 66.7216C87.9653 66.7216 87.2739 65.724 86.5037 66.1834C85.7334 66.6428 85.6592 66.9536 85.6592 66.9536",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3037 73.7109C86.7759 74.0338 87.3526 74.1664 87.9184 74.0821",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2238 74.9453L82.9771 84.5269L82.1094 88.6194L71.7437 77.4695L73.2238 74.9453Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M110.691 111.579C110.691 111.579 107.258 109.537 106.701 109.723C106.144 109.908 100.762 113.806 101.133 114.734C101.504 115.662 104.381 116.868 106.051 117.518C107.722 118.168 111.155 116.776 111.155 116.776L110.691 111.579Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M100.688 110.834C100.688 110.834 103.657 109.164 104.121 109.164C104.585 109.164 107.276 111.577 107.276 111.577L106.163 113.247C106.163 113.247 109.689 115.01 109.318 115.66C108.947 116.31 107.555 117.33 106.07 117.516C104.585 117.702 100.409 115.01 100.409 115.01L100.688 110.834Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_4014_25745",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 109,
    width: 10,
    height: 9
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M100.688 110.834C100.688 110.834 103.657 109.164 104.121 109.164C104.585 109.164 107.276 111.577 107.276 111.577L106.163 113.247C106.163 113.247 109.689 115.01 109.318 115.66C108.947 116.31 107.555 117.33 106.07 117.516C104.585 117.702 100.409 115.01 100.409 115.01L100.688 110.834Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_4014_25745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.688 110.834C100.688 110.834 103.657 109.164 104.121 109.164C104.585 109.164 107.276 111.577 107.276 111.577L106.163 113.247C106.163 113.247 109.689 115.01 109.318 115.66C108.947 116.31 107.555 117.33 106.07 117.516C104.585 117.702 100.409 115.01 100.409 115.01L100.688 110.834Z",
    fill: "#D9D9D9"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M100.688 110.834C100.688 110.834 103.657 109.164 104.121 109.164C104.585 109.164 107.276 111.577 107.276 111.577L106.163 113.247C106.163 113.247 109.689 115.01 109.318 115.66C108.947 116.31 107.555 117.33 106.07 117.516C104.585 117.702 100.409 115.01 100.409 115.01L100.688 110.834Z",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6276 110.094L101.226 110.558L100.391 115.012L98.1636 114.27L98.6276 110.094Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4722 84.2031C68.4722 84.2031 65.9666 89.0287 65.6882 91.4415C65.4098 93.8543 75.6178 113.064 76.3602 113.714C77.1026 114.363 98.8132 115.013 98.8132 115.013L99.7412 110.28L81.1812 104.99L74.8708 85.5951",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_4014_25745",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 84,
    width: 35,
    height: 32
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4732 84.2031C68.4732 84.2031 65.9676 89.0287 65.6892 91.4415C65.4108 93.8543 75.6188 113.064 76.3612 113.714C77.1036 114.363 98.8141 115.013 98.8141 115.013L99.7421 110.28L81.1821 104.99L74.8717 85.5951",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_4014_25745)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M68.4732 84.2031C68.4732 84.2031 65.9676 89.0287 65.6892 91.4415C65.4108 93.8543 75.6188 113.064 76.3612 113.714C77.1036 114.363 98.8141 115.013 98.8141 115.013L99.7421 110.28L81.1821 104.99L74.8717 85.5951",
    fill: "white"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4722 84.2031C68.4722 84.2031 65.9666 89.0287 65.6882 91.4415C65.4098 93.8543 75.6178 113.064 76.3602 113.714C77.1026 114.363 98.8132 115.013 98.8132 115.013L99.7412 110.28L81.1812 104.99L74.8708 85.5951",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M107.444 110.186C107.444 110.186 106.145 109.073 105.681 110.372C105.217 111.671 102.34 114.826 103.639 114.919C104.938 115.012 107.351 112.321 107.351 112.321",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M107.444 110.186C107.444 110.186 106.145 109.073 105.681 110.372C105.217 111.671 102.34 114.826 103.639 114.919C104.938 115.012 107.351 112.321 107.351 112.321",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M101.69 115.386C101.69 115.386 101.356 116.949 102.154 117.613C102.715 118.077 103.031 116.778 102.896 115.85C102.762 114.922 101.968 114.643 101.69 115.386Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M103.008 115.753C103.008 115.753 102.674 117.317 103.472 117.98C104.034 118.444 104.349 117.145 104.215 116.217C104.08 115.289 103.268 115.011 103.008 115.753Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M104.289 116.315C104.289 116.315 103.955 117.879 104.753 118.543C105.314 119.007 105.63 117.707 105.495 116.779C105.36 115.851 104.567 115.573 104.289 116.315Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M105.574 117.069C105.574 117.069 105.268 118.122 106.001 118.568C106.516 118.883 106.808 118.006 106.683 117.38C106.558 116.753 105.829 116.568 105.574 117.069Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M110.691 111.577L110.97 117.516L113.011 116.96L112.547 111.484L110.691 111.577Z",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M112.084 111.016L113.012 118.069L128.51 116.398L128.881 107.211L112.084 111.016Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9117 139.133C84.9117 139.133 82.0999 157.916 82.0999 164.277C82.0999 170.638 77.8125 181.287 77.6641 187.203",
    stroke: "white",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3472 201.834C69.085 202.428 85.6498 202.428 87.1299 201.541C88.6101 200.655 87.8677 199.467 87.2784 199.467C86.6891 199.467 79.293 194.586 79.293 194.586C79.293 194.586 75.2979 197.695 73.08 198.433C70.8621 199.17 67.3125 199.319 67.3125 199.319V200.21C67.5027 200.835 67.8605 201.397 68.3472 201.834Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1299 201.543C87.9094 201.079 88.0579 200.522 87.9651 200.109C85.7897 200.539 83.5797 200.771 81.3624 200.801C76.8941 200.921 69.8645 200.648 67.4424 200.546C67.643 201.044 67.9614 201.487 68.3704 201.835C69.0849 202.429 85.6497 202.429 87.1299 201.543Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8809 200.334L67.3124 199.327L67.9017 187.203C67.9017 187.203 65.2383 196.669 65.0945 198.887C64.9831 200.501 66.2081 200.469 66.8809 200.334Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M130.76 135.438C130.76 135.438 129.284 157.477 130.76 166.349C132.235 175.221 135.952 190.607 136.527 192.528C136.89 193.675 137.047 194.876 136.991 196.078L145.274 197.261C145.274 197.261 142.759 168.126 142.759 164.725C142.759 161.324 145.571 135.883 145.571 135.883L130.76 135.438Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M136.972 196.073C136.972 196.073 127.952 199.92 126.913 200.658C125.874 201.395 129.136 202.435 133.126 202.435C137.116 202.435 141.116 201.971 141.116 201.971L142.74 201.084L142.888 202.119H147.176C147.176 202.119 147.918 198.57 147.64 197.683C147.429 197.077 147.183 196.484 146.902 195.906L136.972 196.073Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M129.428 133.664C129.428 133.664 130.171 154.813 131.943 162.358C133.716 169.903 136.824 188.24 136.824 190.161C136.836 191.259 136.687 192.353 136.384 193.409L135.79 195.339C135.891 195.8 136.047 196.247 136.254 196.671C136.254 196.671 140.096 197.557 142.61 197.557C144.182 197.543 145.744 197.307 147.25 196.856C147.25 196.856 147.329 192.216 147.478 190.012C147.626 187.808 146.889 173.596 146.889 170.195C146.889 166.794 145.998 164.868 145.998 160.729C145.998 156.59 145.26 145.496 145.408 143.719C145.557 141.942 147.626 140.007 148.072 137.803C148.517 135.599 148.958 133.219 148.958 133.219L129.428 133.664Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M131.201 155.898C131.201 155.898 135.335 184.578 136.37 186.388C136.987 187.543 137.152 188.886 136.834 190.156",
    stroke: "white",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M125.879 116.945C125.879 116.945 125.327 122.602 125.327 126.926C125.327 129.339 125.304 132.494 125.28 134.777C125.274 135.716 125.594 136.629 126.187 137.358C126.78 138.087 127.607 138.587 128.528 138.772C129.5 138.986 130.49 139.105 131.484 139.129L128.009 117.609C128.009 117.609 126.436 114.95 125.879 116.945Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M142.3 78.4126C143.147 78.8585 143.92 79.433 144.592 80.1154C145.184 80.8938 145.708 81.7212 146.16 82.5886C146.16 82.5886 152.447 89.8362 152.596 90.574C152.744 91.3118 149.046 114.609 149.046 114.609L153.259 136.645C153.259 136.645 146.457 140.417 141.279 140.64C137.636 140.797 132.156 139.633 129.215 138.927C128.629 138.789 128.103 138.469 127.709 138.015C127.315 137.56 127.074 136.993 127.02 136.394C126.732 133.294 126.194 127.114 125.879 121.263C125.517 114.465 126.547 101 127.271 96.2673C127.994 91.5345 130.305 85.1034 132.078 82.4401C133.85 79.7767 138.736 77.0206 142.3 78.4126Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M146.16 82.5862C145.713 81.7307 145.194 80.9143 144.61 80.1456C143.939 79.4631 143.166 78.8886 142.318 78.4427C139.367 77.278 135.507 78.967 133.266 81.1014C132.969 81.7603 130.63 87.0963 129.521 91.4579C128.338 96.0979 128.486 101.963 128.486 101.963C128.486 101.963 132.407 96.9331 137.729 91.0171C140.387 88.06 143.289 85.3328 146.406 82.8646L146.16 82.5862Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_4014_25745",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 128,
    y: 78,
    width: 19,
    height: 24
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M146.159 82.6018C145.712 81.7463 145.194 80.9299 144.609 80.1612C143.938 79.4787 143.165 78.9043 142.317 78.4583C139.366 77.2937 135.506 78.9826 133.265 81.117C132.968 81.7759 130.629 87.1119 129.52 91.4735C128.337 96.1135 128.485 101.978 128.485 101.978C128.485 101.978 132.406 96.9487 137.728 91.0327C140.386 88.0756 143.288 85.3484 146.405 82.8802L146.159 82.6018Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_4014_25745)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M146.159 82.6018C145.712 81.7463 145.194 80.9299 144.609 80.1612C143.938 79.4787 143.165 78.9043 142.317 78.4583C139.366 77.2937 135.506 78.9826 133.265 81.117C132.968 81.7759 130.629 87.1119 129.52 91.4735C128.337 96.1135 128.485 101.978 128.485 101.978C128.485 101.978 132.406 96.9487 137.728 91.0327C140.386 88.0756 143.288 85.3484 146.405 82.8802L146.159 82.6018Z",
    fill: "white"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M146.16 82.5862C145.713 81.7307 145.194 80.9143 144.61 80.1456C143.939 79.4631 143.166 78.8886 142.318 78.4427C139.367 77.278 135.507 78.967 133.266 81.1014C132.969 81.7603 130.63 87.0963 129.521 91.4579C128.338 96.0979 128.486 101.963 128.486 101.963C128.486 101.963 132.407 96.9331 137.729 91.0171C140.387 88.06 143.289 85.3328 146.406 82.8646L146.16 82.5862Z",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M132.76 84.5048C132.76 84.5048 130.76 90.7735 130.152 92.546C129.544 94.3184 129.484 97.0978 129.484 97.0978C129.484 97.0978 136.973 85.8922 138.801 84.0083C140.629 82.1245 143.019 79.1827 143.019 79.1827L141.409 78.7188L132.76 84.5048Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M133.312 82.2266C133.312 82.2266 132.425 84.8342 132.425 85.0106C132.425 85.1869 132.203 87.6739 132.203 87.6739L135.362 83.4005L133.312 82.2266Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M141.353 77.0234L132.704 84.067L134.036 87.946L142.907 78.9073L141.353 77.0234Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M140.234 132.883C140.234 132.883 139.005 135.941 138.638 136.943C138.272 137.945 138.457 141.87 138.504 142.283C138.55 142.696 139.279 142.785 139.279 142.785C139.279 142.785 139.506 145.93 139.78 146.033C140.064 146.103 140.355 146.148 140.647 146.167C140.647 146.167 141.148 147.768 141.789 147.629C141.981 147.57 142.152 147.457 142.282 147.303C142.411 147.149 142.493 146.961 142.517 146.761C142.728 146.781 142.94 146.745 143.132 146.657C143.324 146.569 143.49 146.432 143.612 146.26C143.873 145.876 144.088 145.464 144.253 145.03C144.253 145.03 145.348 144.483 145.436 144.07C145.524 143.657 145.802 142.214 145.802 142.214C145.802 142.214 146.123 142.121 146.123 141.165C146.123 140.209 145.394 134.321 145.394 134.321L140.234 132.883Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M139.279 142.783L139.413 140.008",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M140.647 146.153L140.944 142.047",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M142.518 146.758L142.731 142.312",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M144.253 145.025L144.517 141.93",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M149.25 88.5547L152.577 90.5499L151.468 113.55L145.552 135.289L139.933 133.813L141.706 116.645L140.819 99.3427C140.819 99.3427 142.077 95.3105 144.958 93.0926",
    fill: "#263238"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M149.25 88.5547L152.577 90.5499L151.468 113.55L145.552 135.289L139.933 133.813L141.706 116.645L140.819 99.3427C140.819 99.3427 142.077 95.3105 144.958 93.0926",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M142.406 92.4375C142.406 92.4375 140.894 96.2794 140.819 99.3511",
    stroke: "white",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M143.668 94.2656C143.668 94.2656 141.079 98.4927 141.079 100.404C141.079 102.316 141.761 118.268 141.761 118.268L139.989 132.04",
    stroke: "white",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M127.6 62.9306C127.6 62.9306 125.823 67.9789 125.99 68.7028C126.157 69.4266 126.324 70.5309 126.324 70.5309C126.324 70.5309 123.54 73.9691 123.883 74.3589C124.227 74.7487 125.767 75.1895 125.767 75.1895C125.767 75.1895 127.043 80.5162 127.544 81.0127C128.045 81.5092 131.15 80.4048 131.15 80.4048L134.476 84.6179L141.297 78.0756L140.467 74.6373C140.467 74.6373 144.072 68.313 144.016 65.3155C143.961 62.3181 137.808 58.3277 133.423 58.3834C129.038 58.4391 124.937 60.0491 125.767 61.2138C126.256 61.9036 126.88 62.4875 127.6 62.9306Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_4014_25745",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 58,
    width: 22,
    height: 27
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M127.6 62.9228C127.6 62.9228 125.823 67.9711 125.99 68.6949C126.157 69.4188 126.324 70.5231 126.324 70.5231C126.324 70.5231 123.54 73.9613 123.883 74.3511C124.227 74.7409 125.767 75.1817 125.767 75.1817C125.767 75.1817 127.043 80.5084 127.544 81.0049C128.045 81.5013 131.15 80.397 131.15 80.397L134.476 84.6101L141.297 78.0677L140.467 74.6295C140.467 74.6295 144.072 68.3052 144.016 65.3077C143.961 62.3103 137.808 58.3199 133.423 58.3756C129.038 58.4313 124.937 60.0413 125.767 61.206C126.256 61.8958 126.88 62.4797 127.6 62.9228Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_4014_25745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.863 61.8438C141.018 61.9672 140.193 62.2012 139.409 62.5397L132.871 65.1892C132.871 65.1892 129.758 67.834 130.087 69.857C130.416 71.8801 133.2 74.6826 132.579 76.7057C131.957 78.7287 128.064 80.9095 128.064 80.9095L129.284 80.9559C130.212 80.7378 131.168 80.3991 131.168 80.3991L131.679 81.0441L137.98 81.2714L141.316 78.0698L140.485 74.6316C140.485 74.6316 144.091 68.3073 144.035 65.3098C143.998 64.2055 143.144 62.9666 141.863 61.8438Z",
    fill: "#B8B8B8"
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M127.6 62.9306C127.6 62.9306 125.823 67.9789 125.99 68.7028C126.157 69.4266 126.324 70.5309 126.324 70.5309C126.324 70.5309 123.54 73.9691 123.883 74.3589C124.227 74.7487 125.767 75.1895 125.767 75.1895C125.767 75.1895 127.043 80.5162 127.544 81.0127C128.045 81.5092 131.15 80.4048 131.15 80.4048L134.476 84.6179L141.297 78.0756L140.467 74.6373C140.467 74.6373 144.072 68.313 144.016 65.3156C143.961 62.3181 137.808 58.3277 133.423 58.3834C129.038 58.4391 124.937 60.0491 125.767 61.2138C126.256 61.9036 126.88 62.4875 127.6 62.9306Z",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M140.467 74.6373C140.467 74.6373 144.072 68.313 144.016 65.3155C143.96 62.3181 137.808 58.3277 133.423 58.3834C129.038 58.4391 124.936 60.0491 125.767 61.2138C126.256 61.9036 126.88 62.4875 127.6 62.9306C127.6 62.9306 130.319 64.2066 130.319 64.5407C130.319 64.8748 128.709 66.6472 129.266 67.4268C129.822 68.2063 132.481 69.1435 132.481 69.1435C132.481 69.1435 132.017 70.6423 132.704 70.8093C133.391 70.9763 133.701 70.3082 134.142 69.8813C134.583 69.4544 136.142 68.8234 136.365 70.7119C136.496 72.0664 136.141 73.4233 135.363 74.5399C135.144 74.7023 138.193 76.7578 139.539 76.1453C139.887 75.9875 140.295 75.7787 140.703 75.5607L140.467 74.6373Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M127.154 71.9115C127.37 71.9115 127.544 71.2405 127.544 70.4128C127.544 69.5851 127.37 68.9141 127.154 68.9141C126.939 68.9141 126.765 69.5851 126.765 70.4128C126.765 71.2405 126.939 71.9115 127.154 71.9115Z",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M127.6 69.8125L134.143 69.8682",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M126.524 68.0016C126.524 68.0016 127.146 67.0086 127.767 68.2475",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M126.398 76.087C127.071 75.8128 127.697 75.4355 128.254 74.9688",
    stroke: "#263238",
    strokeWidth: 0.464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7173 202.445H207.334",
    stroke: "#263238",
    strokeWidth: 0.928,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessdealBro1);
export default __webpack_public_path__ + "static/media/Business deal-bro 1.3065d96139e0162bea39c90358847faf.svg";
export { ForwardRef as ReactComponent };